import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

// No persistence: every slice is built from the bundled snapshot in src/data,
// so rehydrating from localStorage would only risk serving a stale menu.
export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== "production",
});
